// import { useTranslation } from "react-i18next";

import styles from "./UnauthorizedPage.module.scss";

const UnauthorizedPage = () => {
  // const { t } = useTranslation();
  return (
    <div className={styles.error}>
      {/* TODO refactor and redesign this component later */}
      {/* <h1>{t("unauthorizedPage.h1")}</h1>
      <h6>{t("unauthorizedPage.h6")}</h6> */}

      <h1>Whoops, You session has expired</h1>
      <h6>Your session has expired due to your inactivity, please log in again.</h6>
    </div>
  );
};

export default UnauthorizedPage;
